(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6898],{

/***/ 82939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Landing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./components/cart/CartItems.jsx + 6 modules
var CartItems = __webpack_require__(52082);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/cart/OrderSummary/OrderSummary.jsx + 2 modules
var OrderSummary = __webpack_require__(21857);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
;// CONCATENATED MODULE: ./components/cart/LookUpCart/localization.js
const getTranslations = (t)=>{
    return {
        collabrativeCartDecs: t("kf.cart.label.collbcartdecs"),
        customersCartID: t("kf.cart.lable.customercartid"),
        LoadCart: t("Kf.button.action.loadcart"),
        or: t("kf.global.label.or"),
        createcart: t("kf.cart.lable.createcart"),
        invalidcartidError: t("kf.lookup.cart.error.invalidcartid"),
        invalidEmailCartError: t("kf.lookup.cart.error.invalidcartemail"),
        nocartError: t("kf.lookup.cart.error.nocartfound"),
        createNewOrder: "Create New Order"
    };
};

// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var cart = __webpack_require__(33273);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./components/cart/LookUpCart/index.module.scss
var index_module = __webpack_require__(1478);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./js/helperV2.js + 1 modules
var helperV2 = __webpack_require__(83699);
;// CONCATENATED MODULE: ./components/cart/LookUpCart/index.js
















const LookUpCart = (param)=>{
    let { loadAbandonedCart  } = param;
    const [isBtnDisabled, setIsBtnDisabled] = (0,react.useState)(true);
    const [customerCartKey, setCustomerCartKey] = (0,react.useState)("");
    const [error, setError] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)("cart");
    const staticText = getTranslations(t);
    const { user: { sub: userEmail  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { collabrativeCartDecs ="" , customersCartID ="" , LoadCart ="" , or: orText = "" , createNewOrder ="" , invalidcartidError , invalidEmailCartError , nocartError  } = staticText;
    const handleChange = (e)=>{
        const { value  } = e.target;
        setError("");
        setCustomerCartKey(value);
        setIsBtnDisabled(false);
    };
    const getToken = async ()=>{
        const response = await api/* apim.post */.TH.post("".concat(constants.oktaTokenEndpoint, "?scope=guest&channel=india"), null, {
            params: {}
        });
        const { access_token: accessToken = ""  } = response.data;
        return accessToken;
    };
    const handleCreateCart = async ()=>{
        const guestToken = await getToken();
        await (0,helper.getCurrency)().then((currency)=>{
            const cartPayload = {
                currency: "INR"
            };
            (0,cart/* removeCustomerCartId */.w$)();
            dispatch((0,cartSlice/* setCartCount */.oJ)(0));
            dispatch((0,cartSlice/* createCartISCUser */.i5)({
                cartPayload,
                guestToken
            })).unwrap().then((res)=>{
                (0,cart/* setCustomerCartId */.VN)(res.id);
                dispatch((0,cartSlice/* setCart */.RV)(res));
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: "Cart created successfully",
                    isVisible: true
                }));
            });
        });
    };
    const handleLoadCart = ()=>{
        const payload = {};
        let valid = false;
        if (customerCartKey.length === 9) {
            valid = true;
            payload.klId = customerCartKey;
        } else if ((0,helperV2/* validateEmail */.oH)(customerCartKey)) {
            valid = true;
            payload.email = customerCartKey;
        }
        if (valid) {
            dispatch((0,cartSlice/* getCart */.dv)(payload)).unwrap().then((res)=>{
                var ref, ref1;
                setError("");
                if (res.cartState === "Ordered") {
                    setError("order is placed for this cart.");
                    dispatch((0,cartSlice/* setCart */.RV)({}));
                } else if (res.id && (res === null || res === void 0 ? void 0 : (ref = res.lineItems) === null || ref === void 0 ? void 0 : ref.length)) {
                    (0,cart/* setCustomerCartId */.VN)(res.id);
                    loadAbandonedCart(true);
                } else if ((res === null || res === void 0 ? void 0 : (ref1 = res.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length) === 0) {
                    setError("No lineitems present for your cart.");
                    dispatch((0,cartSlice/* setCart */.RV)({}));
                } else {
                    setError(nocartError);
                }
            }).catch((error)=>{
                if (customerCartKey.length === 9) {
                    setError(invalidcartidError);
                } else {
                    setError(nocartError);
                }
            });
        } else {
            setError(invalidcartidError);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).cartIsfcUser,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cart-ifsc-section",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "isfc-description",
                    children: collabrativeCartDecs
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "isfc-cart__input-group",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "customers-cart-id",
                            type: "text",
                            label: customersCartID,
                            value: customerCartKey,
                            showError: error,
                            errorMessage: error,
                            onChange: handleChange,
                            autoComplete: "off"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            tabIndex: "0",
                            label: LoadCart,
                            size: "large",
                            type: "black",
                            className: "cart-load",
                            disabled: customerCartKey !== "" ? false : true,
                            onClick: handleLoadCart
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "btn-group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "middle-or",
                                    children: orText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "create-cart-button",
                                    role: "button",
                                    tabIndex: "0",
                                    label: createNewOrder,
                                    size: "large",
                                    type: "ghost",
                                    onClick: handleCreateCart
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var cart_LookUpCart = (LookUpCart);

// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./components/cart/QuantityModal/index.module.scss
var QuantityModal_index_module = __webpack_require__(68122);
var QuantityModal_index_module_default = /*#__PURE__*/__webpack_require__.n(QuantityModal_index_module);
;// CONCATENATED MODULE: ./components/cart/QuantityModal/QuantityModal.jsx




const QuantityModal = (param)=>{
    let { showModal , setShowModal , modalText  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (QuantityModal_index_module_default()).quantityModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            showModal: showModal,
            onModalClose: ()=>setShowModal(false),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "quantity-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "quantity-modal__header",
                        children: [
                            "The number of installation services may have changed to match the updated product quantity.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "quantity-modal__button",
                        label: "Continue",
                        flexible: true,
                        type: "black",
                        onClick: ()=>setShowModal(false),
                        role: "button"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/cart/BreakBundle/break-bundle.module.scss
var break_bundle_module = __webpack_require__(46104);
var break_bundle_module_default = /*#__PURE__*/__webpack_require__.n(break_bundle_module);
;// CONCATENATED MODULE: ./components/cart/BreakBundle/BreakBundle.jsx






const BreakBundle = (param)=>{
    let { showModal , setShowModal , onConfirm  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("cart");
    const handleConfirm = ()=>{
        setLoading(true);
        onConfirm().finally(()=>{
            setLoading(false);
            setShowModal(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (break_bundle_module_default()).breakBundle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            showModal: showModal,
            onModalClose: ()=>setShowModal(false),
            hideCloseIcon: loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bundle-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bundle-modal__title",
                        children: t("kf.bundle.warningTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "bundle-modal__desc",
                        children: t("kf.bindle.warningMessage")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bundle-modal__cta",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                customClass: "bundle-modal__button",
                                label: "Yes",
                                flexible: true,
                                type: "black",
                                onClick: handleConfirm,
                                loading: loading,
                                role: "button"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                customClass: "bundle-modal__button",
                                label: "No",
                                flexible: true,
                                type: "ghost",
                                onClick: ()=>setShowModal(false),
                                disabled: loading,
                                role: "button"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var BreakBundle_BreakBundle = (BreakBundle);

// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./components/cart/localization.js
var localization = __webpack_require__(96286);
// EXTERNAL MODULE: ./utils/removeCart.js
var removeCart = __webpack_require__(3783);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./components/Shared/CustomerInformation/index.module.scss
var CustomerInformation_index_module = __webpack_require__(61047);
var CustomerInformation_index_module_default = /*#__PURE__*/__webpack_require__.n(CustomerInformation_index_module);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Shared/CustomerInformation/ContactCustomerModal.js






function ContactCustomerModal(props) {
    const { staticText , showModal , closeModal , contactViaEmail , contactViaPhone  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            showModal: showModal,
            onModalClose: closeModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ContactCustomerModal__wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ContactCustomerModal__info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ContactCustomerModal__title",
                                children: staticText.customerInformation
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ContactCustomerModal__description",
                                children: staticText.howToContact
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ContactCustomerModal__ctas",
                        children: [
                            contactViaPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                tag: "anchor",
                                label: staticText.phone,
                                flexible: true,
                                to: contactViaPhone
                            }) : null,
                            contactViaEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                tag: "anchor",
                                label: staticText.email,
                                type: "ghost",
                                flexible: true,
                                to: contactViaEmail
                            }) : null
                        ]
                    })
                ]
            })
        })
    });
}
ContactCustomerModal.propTypes = {
    showModal: prop_types.bool,
    closeModal: prop_types.func,
    contactViaPhone: prop_types.func,
    contactViaEmail: prop_types.func
};
/* harmony default export */ var CustomerInformation_ContactCustomerModal = (ContactCustomerModal);

// EXTERNAL MODULE: ./components/cart/utils.js
var utils = __webpack_require__(65875);
;// CONCATENATED MODULE: ./components/Shared/CustomerInformation/index.js







function CustomerInformation(props) {
    const { address ={} , email ="" , staticText  } = props;
    const [showContactCustomerModal, setShowContactCustomerModal] = (0,react.useState)(false);
    const { phone =""  } = address;
    const formattedMobileNumber = (0,react.useMemo)(()=>(0,utils/* formatMobileNumber */.IC)(phone), [
        phone
    ]);
    const formattedName = (0,react.useMemo)(()=>(0,utils/* formatName */.KY)(address), [
        address
    ]);
    const formattedAddress = (0,react.useMemo)(()=>(0,utils/* formatAddress */.Tg)(address), [
        address
    ]);
    const handleContactCustomer = ()=>{
        setShowContactCustomerModal(true);
    };
    const contactViaEmail = "mailto:".concat(email);
    const contactViaPhone = "tel:".concat(phone);
    const isContactCustomerButtonDisabled = !email && !phone && !formattedMobileNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CustomerInformation_index_module_default()).CustomerInformationWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "CustomerInformation__title",
                children: staticText.customerInformation
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "CustomerInformation__field-wrapper",
                children: [
                    formattedName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CustomerInformation__name CustomerInformation__field",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__name CustomerInformation__field-title",
                                children: staticText.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__name CustomerInformation__field-value",
                                children: formattedName
                            })
                        ]
                    }) : null,
                    email ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CustomerInformation__email CustomerInformation__field",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__email CustomerInformation__field-title",
                                children: staticText.email
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__email CustomerInformation__field-value",
                                children: email
                            })
                        ]
                    }) : null,
                    formattedMobileNumber ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CustomerInformation__mobile CustomerInformation__field",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__mobile CustomerInformation__field-title",
                                children: staticText.mobileNumber
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "CustomerInformation__mobile CustomerInformation__field-value",
                                children: [
                                    "+91",
                                    formattedMobileNumber
                                ]
                            })
                        ]
                    }) : null,
                    formattedAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "CustomerInformation__address CustomerInformation__field",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__address CustomerInformation__field-title",
                                children: staticText.address
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "CustomerInformation__address CustomerInformation__field-value",
                                children: formattedAddress
                            })
                        ]
                    }) : null
                ]
            }),
            formattedMobileNumber || email ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                ariaLabel: staticText.contactCustomer,
                className: "gbh-data-layer CustomerInformation__contactCustomer-btn",
                label: staticText.contactCustomer,
                flexible: true,
                type: "ghost",
                onClick: handleContactCustomer,
                disabled: isContactCustomerButtonDisabled
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerInformation_ContactCustomerModal, {
                staticText: staticText,
                contactViaEmail: email ? contactViaEmail : null,
                contactViaPhone: formattedMobileNumber ? contactViaPhone : null,
                showModal: showContactCustomerModal,
                closeModal: ()=>setShowContactCustomerModal(false)
            })
        ]
    });
}
CustomerInformation.propTypes = {
    name: prop_types.string,
    email: prop_types.string,
    mobile: prop_types.string,
    address: prop_types.object,
    buttonLabel: prop_types.string
};
CustomerInformation.defaultProps = {
    name: "",
    email: "",
    mobile: "",
    address: {},
    buttonLabel: "Contact Customer"
};
/* harmony default export */ var Shared_CustomerInformation = (CustomerInformation);

// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/cart/LandingFiller.jsx
var LandingFiller = __webpack_require__(22657);
// EXTERNAL MODULE: ./components/checkout/StickyButton.jsx
var StickyButton = __webpack_require__(7653);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./components/cart/CartInfo.jsx
var CartInfo = __webpack_require__(65143);
// EXTERNAL MODULE: ./components/checkout/CartUpdatedModal/index.jsx + 1 modules
var CartUpdatedModal = __webpack_require__(92062);
;// CONCATENATED MODULE: ./components/cart/Landing.jsx







// import CartInfo from "@/components/cart/CartInfo"

























const CartLanding = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const { contactnumber  } = props.data;
    const { t  } = (0,esm/* useTranslation */.$G)("cart");
    const { cart: activeCart = {} , status , promoError , noShippingItemsInCheckout , shippingItemstoCheckout , isCartLoading =false , isCheckoutMergeModal =false  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { isAuth , user: { firstName ="" , sub ="" , persona =[]  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const isIscUser = persona === null || persona === void 0 ? void 0 : persona.includes("IN_Kohler_ISC");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const [zipcode, setZipcode] = (0,react.useState)("");
    const [redirect, setRedirect] = (0,react.useState)(false);
    const [abandonedFlag, showAbandonedCarts] = (0,react.useState)(false);
    const qtyLoading = false;
    const [showAlert, setShowAlert] = (0,react.useState)(false);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [showBundleModal, setShowBundleModal] = (0,react.useState)(false);
    const [stickyCheckout, setStickyCheckout] = (0,react.useState)(true);
    const [checkoutSeen, setCheckoutSeen] = (0,react.useState)(false);
    const [isAbandonedCart, setAbandonedCart] = (0,react.useState)(isIscUser && (0,cart/* getCustomerCartId */.cS)() ? true : false);
    const [modalText, setModalText] = (0,react.useState)("");
    const [errors, setErrors] = (0,react.useState)({});
    const [inventoryData, setInventoryData] = (0,react.useState)({
        nonDeliverableData: [],
        outOfStockData: [],
        installationServiceData: []
    });
    const [cartData, setCartData] = (0,react.useState)({});
    const [cartLoad, setCartLoad] = (0,react.useState)(true);
    const [cartQtyLoad, setCartQtyLoad] = (0,react.useState)(true);
    const [isFirstVisit, setIsFirstVisit] = (0,react.useState)(true);
    const [promoCodesList, setPromoCodesList] = (0,react.useState)([]);
    const [applicablePromos, setApplicablePromos] = (0,react.useState)([]);
    const [promo, setPromo] = (0,react.useState)("");
    const [loadingText, setLoadingText] = (0,react.useState)(null);
    const checkoutUrl = (0,react.useRef)("");
    const currencySign = (0,react.useRef)("");
    const dispatch = (0,es/* useDispatch */.I0)();
    const pageRenderRef = (0,react.useRef)({
        isFirstRenderDone: false
    });
    const childRef = (0,react.useRef)();
    const { key: cartKey = ""  } = activeCart;
    const inventoryCheck = async function() {
        let pin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        try {
            var ref;
            const pinCodeForInventory = pin ? pin : zipcode;
            const { inventoryData: errorData , newLineItems  } = await (0,cartHelper/* checkInventory */.q1)(false, pinCodeForInventory, true);
            if ((ref = Object === null || Object === void 0 ? void 0 : Object.keys(errorData)) === null || ref === void 0 ? void 0 : ref.length) {
                const { nonDeliverableData , outOfStockData , installationServiceData  } = (0,cartHelper/* calculateInventoryStatus */._S)(newLineItems);
                setInventoryData({
                    nonDeliverableData,
                    outOfStockData,
                    installationServiceData
                });
                setShowAlert(true);
            } else {
                setInventoryData({
                    nonDeliverableData: [],
                    outOfStockData: [],
                    installationServiceData: []
                });
                setShowAlert(false);
            }
            setErrors(errorData);
            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
            setTimeout(()=>{
                var ref, ref1;
                const itemId = (ref = store/* store */.h === null || store/* store */.h === void 0 ? void 0 : store/* store.getState */.h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.itemId;
                if (itemId && itemId !== "") (0,cartHelper/* scrollToError */.HZ)(false, itemId);
            }, 500);
            return errorData;
        } catch (e) {
            setShowAlert(false);
            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
            return true;
        }
    };
    const loadAbandonedCart = (cartState)=>{
        setAbandonedCart(cartState);
    };
    const initialCartLoad = ()=>{
        try {
            dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
            dispatch((0,cartSlice/* getCart */.dv)()).unwrap().then(async function() {
                let rsp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var ref;
                const { cartExists ="" , error =""  } = rsp;
                if (cartExists === "false" && error === "No active cart exists.") {
                    dispatch((0,cartSlice/* createCart */.Bk)({
                        currency: "INR"
                    })).unwrap().catch((ex)=>console.log(ex)).finally(()=>{
                        dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                    });
                } else if (rsp === null || rsp === void 0 ? void 0 : (ref = rsp.lineItems) === null || ref === void 0 ? void 0 : ref.length) {
                    dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                    const payload = {
                        actions: [
                            {
                                action: "recalculate",
                                updateProductData: true
                            },
                            {
                                action: "calculateTax"
                            },
                            {
                                action: "syncCartPrices"
                            }
                        ]
                    };
                    const calcTax = ()=>{
                        dispatch((0,cartSlice/* addToCart */.Xq)(payload)).unwrap().then(async (rsp)=>{
                            const zipCode = await getZipCode(rsp);
                            await inventoryCheck(zipCode);
                        }).catch((e)=>{
                            console.log(e);
                            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                        });
                    };
                    if (document.prerendering) {
                        document.addEventListener("prerenderingchange", calcTax, {
                            once: true
                        });
                    } else {
                        calcTax();
                    }
                } else {
                    dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                }
            }).catch((e)=>{
                console.log(e);
                dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
            });
        } catch (e) {
            console.log(e);
            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
        }
    };
    const getPromoCodes = async function() {
        let quantityChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref;
        const applicablePromos = await (0,cartHelper/* getPromoCodeList */.jE)((ref = cartData.cart) === null || ref === void 0 ? void 0 : ref.cartID);
        setApplicablePromos(applicablePromos);
        updatePromoList(applicablePromos);
        if (quantityChange) {
            var ref1;
            if (activeCart === null || activeCart === void 0 ? void 0 : (ref1 = activeCart.promoCode) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var ref2;
                setPromo(activeCart === null || activeCart === void 0 ? void 0 : (ref2 = activeCart.promoCode) === null || ref2 === void 0 ? void 0 : ref2[0].code);
            } else {
                setPromo("");
            }
        }
    };
    const updatePromoList = (applicableCodes)=>{
        var ref, ref1;
        const codes = applicableCodes ? applicableCodes : applicablePromos;
        const activePromo = (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.promoCodes) === null || ref === void 0 ? void 0 : ref.length) ? cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.promoCodes) === null || ref1 === void 0 ? void 0 : ref1[0] : "";
        let promoList = codes.map((item)=>{
            if (item.code === activePromo.code) {
                item.isApplied = true;
                item.id = activePromo.id;
                item.discount = activePromo.discount;
            } else {
                item.isApplied = false;
            }
            return item;
        });
        if (activePromo !== "") {
            const index = codes.findIndex((item)=>item.code === activePromo.code);
            if (index === -1) {
                promoList = [
                    {
                        isApplied: true,
                        id: activePromo.id,
                        discount: activePromo.discount,
                        code: activePromo.code,
                        description: activePromo.description
                    },
                    ...promoList
                ];
                promoList = promoList.length > 3 ? promoList.slice(0, 3) : promoList;
            }
        }
        setPromoCodesList(promoList);
    };
    (0,react.useEffect)(()=>{
        initialCartLoad();
        (0,config/* getConfig */.i)().then(async (config)=>{
            currencySign.current = get_default()(config, "internationalization.currencySign", "");
            checkoutUrl.current = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.checkoutPagePath", ""));
        });
    }, []);
    (0,react.useEffect)(()=>{
        var ref;
        if ((ref = cartData.cart) === null || ref === void 0 ? void 0 : ref.cartID) getPromoCodes();
    }, [
        (ref = cartData.cart) === null || ref === void 0 ? void 0 : ref.cartID
    ]);
    (0,react.useEffect)(()=>{
        updatePromoList();
    }, [
        cartData.promoCodes
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && redirect === false) {
            var ref1, ref2;
            dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
            (0,helper.calculateCartData)({
                cart: activeCart,
                shippingItemstoCheckout: shippingItemstoCheckout,
                noShippingItems: noShippingItemsInCheckout,
                quantityUpdatedFlag: (window === null || window === void 0 ? void 0 : (ref1 = window.pageObj) === null || ref1 === void 0 ? void 0 : ref1.updatedSku) ? window === null || window === void 0 ? void 0 : (ref2 = window.pageObj) === null || ref2 === void 0 ? void 0 : ref2.updatedSku : false
            }, true).then(async (rsp)=>{
                var ref, ref1;
                if (rsp === null || rsp === void 0 ? void 0 : (ref = rsp.promoCodes) === null || ref === void 0 ? void 0 : ref.length) {
                    var ref2;
                    setPromo(rsp === null || rsp === void 0 ? void 0 : (ref2 = rsp.promoCodes) === null || ref2 === void 0 ? void 0 : ref2[0].code);
                } else {
                    setPromo("");
                }
                if (window === null || window === void 0 ? void 0 : (ref1 = window.pageObj) === null || ref1 === void 0 ? void 0 : ref1.updatedSku) {
                    delete window.pageObj.updatedSku;
                }
                if (window.pageObj) {
                    window.pageObj.cart = rsp.cart;
                }
                (0,cartAnalytics/* analyticsCB */.u$)("success", rsp.cart);
                let windowDataLayer = window.adobeDataLayer;
                if (windowDataLayer && windowDataLayer.length > 0 && windowDataLayer[0].page) {
                    (0,cartAnalytics/* calculateCartAnalytics */.uU)({
                        cart: rsp.cart
                    });
                    windowDataLayer = window.adobeDataLayer;
                    if (windowDataLayer.length > 1 && windowDataLayer[windowDataLayer.length] && windowDataLayer[windowDataLayer.length].event && (windowDataLayer[windowDataLayer.length].event === "cmp:show" || windowDataLayer[windowDataLayer.length].event === "cmp:click") && windowDataLayer[windowDataLayer.length].page && !windowDataLayer[windowDataLayer.length].page.cart) {
                        windowDataLayer[windowDataLayer.length].page.cart = rsp.cart;
                    }
                }
                setCartData((prevState)=>{
                    var ref;
                    if (!prevState) {
                        return rsp;
                    }
                    const newData = {
                        ...rsp
                    };
                    (ref = newData.cartItems) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
                        if (!item.isBundleChildItem && item.category !== "Install Services") {
                            var ref;
                            const d = (ref = prevState.cartItems) === null || ref === void 0 ? void 0 : ref.find((i)=>i.id === item.id);
                            if (d && d.isSelected) {
                                item.isSelected = d.isSelected;
                            }
                        }
                    });
                    return newData;
                });
                setCartLoad(false);
                setCartQtyLoad(false);
                dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
            });
        } else if (Object.keys(activeCart).length === 0 || (activeCart === null || activeCart === void 0 ? void 0 : (ref = activeCart.lineItems) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            setCartData({});
            setCartLoad(false);
            setCartQtyLoad(false);
            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
        }
        return ()=>setShowAlert(false);
    }, [
        activeCart,
        shippingItemstoCheckout,
        noShippingItemsInCheckout
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((pageRenderRef === null || pageRenderRef === void 0 ? void 0 : pageRenderRef.current["isFirstRenderDone"]) && (activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && (activeCart === null || activeCart === void 0 ? void 0 : (ref = activeCart.lineItems) === null || ref === void 0 ? void 0 : ref.length)) {
            inventoryCheck();
        }
        if (pageRenderRef === null || pageRenderRef === void 0 ? void 0 : pageRenderRef.current) {
            pageRenderRef.current["isFirstRenderDone"] = true;
        }
        return ()=>setShowAlert(false);
    }, [
        activeCart === null || activeCart === void 0 ? void 0 : (ref1 = activeCart.lineItems) === null || ref1 === void 0 ? void 0 : ref1.length
    ]);
    const handleAddtoCartResponse = (param)=>{
        let { payload  } = param;
        if (payload) {
            var ref;
            dispatch((0,cartSlice/* setCart */.RV)(payload));
            if ((payload === null || payload === void 0 ? void 0 : (ref = payload.lineItems) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                setShowAlert(false);
            }
        }
    };
    const handleQuantityChange = async function(sku, quantity, isBundle, masterVariantKey, stockCheck, cb) {
        let productData = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, id = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
        const { isInstallService , installServiceName , installServiceQty , totalInstallServiceQty , isInstallItem , cartQuantity , lineItemId , curWarehouses =[] , section  } = (0,helper.getProductDetails)(activeCart, sku, isBundle, productData);
        let payload;
        let isBundleWithInstall = false;
        if (quantity < cartQuantity) {
            setLoadingText("Loading...");
        }
        try {
            dispatch((0,cartSlice/* setCardStatus */.YZ)(true));
            setCartQtyLoad(true);
            let pincode = await (0,cartHelper/* getPincode */.pf)();
            if (!pincode) {
                var ref;
                pincode = activeCart === null || activeCart === void 0 ? void 0 : (ref = activeCart.billingAddress) === null || ref === void 0 ? void 0 : ref.postalCode;
            }
            if (isBundle) {
                isBundleWithInstall = (0,utils/* isBundleWithInstallation */.u1)(sku, activeCart.lineItems);
            }
            if (isInstallItem) {
                const isBundleInstallService = productData.isBundleParent;
                const { installServiceName: installServiceName1 , installServiceQty: installServiceQty1 , lineItemId: productLineItemId  } = (0,helper.getProductDetails)(activeCart, productData === null || productData === void 0 ? void 0 : productData.sku);
                let warehouses = [];
                if (!isBundleInstallService) {
                    warehouses = await (0,cartHelper/* getETA */.c5)(productData.sku, productData.masterVariantKey, productData.quantity, pincode);
                }
                let payload1;
                // installation service decrease
                if (installServiceQty1 > quantity) {
                    payload1 = (0,removeCart/* removeFromCart */.h2)({
                        id: lineItemId,
                        quantity: installServiceQty1 - quantity,
                        isComboSku: isBundle
                    });
                } else {
                    payload1 = [
                        {
                            action: isBundleInstallService ? "changeBundleSKUQuantity" : "changeLineItemQuantity",
                            lineItemId: isBundleInstallService ? id : lineItemId,
                            quantity: quantity
                        }
                    ];
                }
                let payload2 = [];
                if (!isBundleInstallService) {
                    payload2 = [
                        {
                            action: "setLineItemCustomType",
                            lineItemId: productLineItemId,
                            type: {
                                key: "cartLineItemAdditionalInfo",
                                typeId: "type"
                            },
                            fields: {
                                associatedService: installServiceName1,
                                associatedServiceQty: quantity,
                                warehouses,
                                section
                            }
                        }
                    ];
                }
                payload = [
                    ...payload1,
                    ...payload2
                ];
            } else {
                let warehouses1 = curWarehouses;
                if (quantity > cartQuantity) {
                    warehouses1 = await (0,cartHelper/* getETA */.c5)(sku, masterVariantKey, quantity, pincode, false, isBundle, ()=>cb(staticText.noItemsToShip));
                }
                if (isBundle && !warehouses1) {
                    dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                    setCartQtyLoad(false);
                    return;
                }
                // product quantity decrease
                if (cartQuantity > quantity) {
                    const qty = cartQuantity - quantity;
                    payload = isBundle ? (0,removeCart/* changeBundleQty */.Wj)(lineItemId, sku, quantity, warehouses1, isBundleWithInstall) : (0,removeCart/* removeFromCart */.h2)({
                        id: lineItemId,
                        quantity: qty,
                        isComboSku: isBundle
                    });
                    if (isInstallService) {
                        const currentInstallationQty = totalInstallServiceQty - qty;
                        const productInstallationQty = installServiceQty - qty;
                        let installationLineItemId = null;
                        if (isBundle) {
                            var ref1, ref2;
                            installationLineItemId = (ref2 = (ref1 = productData.bundleItems) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.category === "Install Services")) === null || ref2 === void 0 ? void 0 : ref2.id;
                        } else {
                            const { lineItemId: lineItemId1  } = (0,helper.getProductDetails)(activeCart, installServiceName, false, productData);
                            installationLineItemId = lineItemId1;
                        }
                        const payload21 = [
                            {
                                action: isBundle ? "changeBundleSKUQuantity" : "changeLineItemQuantity",
                                lineItemId: installationLineItemId,
                                quantity: productInstallationQty > 0 ? currentInstallationQty : totalInstallServiceQty - (installServiceQty - 1)
                            }
                        ];
                        if (!isBundle) {
                            payload21.push({
                                action: "setLineItemCustomType",
                                lineItemId: lineItemId,
                                type: {
                                    key: "cartLineItemAdditionalInfo",
                                    typeId: "type"
                                },
                                fields: {
                                    associatedService: installServiceName,
                                    associatedServiceQty: productInstallationQty > 0 ? productInstallationQty : 1,
                                    warehouses: warehouses1,
                                    section
                                }
                            });
                        }
                        payload = [
                            ...payload,
                            ...payload21
                        ];
                        setModalText("decreased");
                    } else {
                        if (!isBundle) {
                            const payload22 = [
                                {
                                    action: "setLineItemCustomType",
                                    lineItemId,
                                    type: {
                                        key: "cartLineItemAdditionalInfo",
                                        typeId: "type"
                                    },
                                    fields: {
                                        warehouses: warehouses1,
                                        section
                                    }
                                }
                            ];
                            payload = [
                                ...payload,
                                ...payload22
                            ];
                        }
                    }
                } else {
                    let currentQty;
                    const stock = await (0,cart/* getStock */.K5)(sku);
                    if (stock === cartQuantity) {
                        const msg = staticText.noItemsToShip;
                        cb(msg);
                        dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                        setCartQtyLoad(false);
                        setCartLoad(false);
                        setCartQtyLoad(false);
                        dispatch((0,cartSlice/* getCart */.dv)());
                        return;
                    } else if (stock <= 0) {
                        const msg1 = staticText.outOfStock;
                        dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                        setCartLoad(false);
                        setCartQtyLoad(false);
                        cb(msg1);
                        return;
                    } else if (quantity > stock) {
                        currentQty = stock - cartQuantity;
                        payload = isBundle ? (0,removeCart/* changeBundleQty */.Wj)(lineItemId, sku, currentQty + cartQuantity, warehouses1, isBundleWithInstall) : [
                            {
                                action: "changeLineItemQuantity",
                                lineItemId,
                                quantity: currentQty + cartQuantity
                            }
                        ];
                        const msg2 = t("kf.cart.label.availableToShip", {
                            qty: stock
                        });
                        cb(msg2);
                    } else {
                        currentQty = quantity - cartQuantity;
                        payload = isBundle ? (0,removeCart/* changeBundleQty */.Wj)(lineItemId, sku, quantity, warehouses1, isBundleWithInstall) : [
                            {
                                action: "changeLineItemQuantity",
                                lineItemId,
                                quantity
                            }
                        ];
                    }
                    if (isInstallService) {
                        let installationLineItemId1 = null;
                        if (isBundle) {
                            var ref3, ref4;
                            installationLineItemId1 = (ref4 = (ref3 = productData.bundleItems) === null || ref3 === void 0 ? void 0 : ref3.find((item)=>item.category === "Install Services")) === null || ref4 === void 0 ? void 0 : ref4.id;
                        } else {
                            const { lineItemId: lineItemId2  } = (0,helper.getProductDetails)(activeCart, installServiceName, false, productData);
                            installationLineItemId1 = lineItemId2;
                        }
                        const payload23 = [
                            {
                                action: isBundle ? "changeBundleSKUQuantity" : "changeLineItemQuantity",
                                lineItemId: installationLineItemId1,
                                quantity: totalInstallServiceQty + currentQty
                            }
                        ];
                        if (!isBundle) {
                            payload23.push({
                                action: "setLineItemCustomType",
                                lineItemId,
                                type: {
                                    key: "cartLineItemAdditionalInfo",
                                    typeId: "type"
                                },
                                fields: {
                                    associatedService: installServiceName,
                                    associatedServiceQty: installServiceQty + currentQty,
                                    warehouses: warehouses1,
                                    section
                                }
                            });
                        }
                        payload = [
                            ...payload,
                            ...payload23
                        ];
                        setModalText("increased");
                    } else {
                        if (!isBundle) {
                            const payload24 = [
                                {
                                    action: "setLineItemCustomType",
                                    lineItemId,
                                    type: {
                                        key: "cartLineItemAdditionalInfo",
                                        typeId: "type"
                                    },
                                    fields: {
                                        warehouses: warehouses1,
                                        section
                                    }
                                }
                            ];
                            payload = [
                                ...payload,
                                ...payload24
                            ];
                        }
                    }
                }
            }
            payload.push({
                action: "calculateTax"
            });
            const body = {
                actions: payload
            };
            dispatch((0,cartSlice/* addToCart */.Xq)(body)).unwrap().then((res)=>{
                handleAddtoCartResponse(res);
                // getShippingMethods()
                // dispatchCallbackHandler("taxCalculation")
                dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                setCartLoad(false);
                setCartQtyLoad(false);
                isInstallService && isFirstVisit && setShowModal(true);
                if (isInstallService) setIsFirstVisit(false);
                getPromoCodes(true);
                setLoadingText(null);
            }).catch((e)=>{
                dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
                setCartLoad(false);
                setCartQtyLoad(false);
                setLoadingText(null);
            });
        } catch (e) {
            dispatch((0,cartSlice/* setCardStatus */.YZ)(false));
            setCartQtyLoad(false);
            setCartLoad(false);
            setLoadingText(null);
            console.log(e);
        }
    };
    const dispatchCallbackHandler = function(type) {
        let payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        switch(type){
            case "discount":
                {
                    return dispatch((0,cartSlice/* discount */.Al)(payload));
                }
            case "taxCalculation":
                {
                    return dispatch((0,cartSlice/* taxCalculation */.QL)());
                }
            case "shipmentUpdate":
                {
                    return dispatch((0,cartSlice/* shipmentUpdate */.NM)(payload));
                }
            case "shareCart":
                {
                    return dispatch((0,cartSlice/* shareCart */.Vp)(payload));
                }
            case "addToCart":
                {
                    return dispatch((0,cartSlice/* addToCart */.Xq)(payload));
                }
            case "shipmentcart":
                {
                    return dispatch((0,cartSlice/* shipmentCart */.pw)());
                }
        }
    };
    const getZipCode = async (payload)=>{
        // const { postalCode, state, country } = activeCart?.shippingAddress ?? {}
        try {
            var ref;
            const { postalCode , state , country  } = (ref = payload === null || payload === void 0 ? void 0 : payload.shippingAddress) !== null && ref !== void 0 ? ref : {};
            if (postalCode && state && country) {
                const shippingZip = localStorage.getItem("shippingZip");
                if (!shippingZip) {
                    localStorage.setItem("shippingZip", postalCode);
                }
                setZipcode(postalCode);
                await (0,cartHelper.getShippingMethods)();
                return postalCode;
            }
            const getCookieValue = (name)=>{
                var ref;
                return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
            };
            let zip = getCookieValue("pincode");
            if (!zip && isAuth && !isIscUser) {
                const profile = await (0,cartHelper/* getProfileData */.$y)(staticText.profileFailure);
                if (profile === null || profile === void 0 ? void 0 : profile.addresses) {
                    const defAddr = profile.defaultShippingAddressId ? profile.addresses.find((item)=>item.id === profile.defaultShippingAddressId) : profile.addresses[0];
                    zip = defAddr === null || defAddr === void 0 ? void 0 : defAddr.postalCode;
                }
            }
            setZipcode(zip);
            return zip;
        } catch (e) {
            console.error(e);
        }
    };
    const showToastHandler = (msg)=>dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    const returnToCart = ()=>{
        (0,cartHelper/* clearCartFromStore */.aJ)(sub);
        showAbandonedCarts(!abandonedFlag);
    };
    const handleBundleBreak = async ()=>{
        await (0,cartHelper/* breakBundleItem */.V7)(showBundleModal);
    };
    const recoveredStatus = activeCart === null || activeCart === void 0 ? void 0 : (ref2 = activeCart.custom) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : ref3.recoveredStatus;
    const handleStickyCheckout = ()=>{
        if (childRef.current) {
            childRef.current.handleCheckout();
        }
    };
    const CHECKOUT_BUTTON_LABEL = isAbandonedCart ? staticText.checkoutAsCustomer : staticText.checkout;
    const handleSelection = (id, isSelected)=>{
        setCartData((cart)=>{
            var ref;
            const newData = {
                ...cart
            };
            (ref = newData.cartItems) === null || ref === void 0 ? void 0 : ref.forEach((item)=>{
                if (!item.isBundleChildItem && item.category !== "Install Services") {
                    if (!id || item.id === id) {
                        item.isSelected = isSelected;
                    }
                }
            });
            return newData;
        });
    };
    if (cartLoad) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFiller/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: cartQtyLoad,
                cartLoading: true,
                text: loadingText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "root container responsivegrid",
                id: "main-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                        stickyCheckout: stickyCheckout,
                        handleCheckout: handleStickyCheckout,
                        checkoutSeen: checkoutSeen,
                        setCheckoutSeen: setCheckoutSeen,
                        checkoutLabel: CHECKOUT_BUTTON_LABEL,
                        checkoutFlag: true,
                        i18n: staticText,
                        disableCheckout: (cartData === null || cartData === void 0 ? void 0 : (ref4 = cartData.cartItems) === null || ref4 === void 0 ? void 0 : ref4.length) === 0 || showAlert
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "container-181c79087e",
                        className: "cmp-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container responsivegrid",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "container-9241f43c45",
                                className: "cmp-container",
                                children: [
                                    isIscUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_LookUpCart, {
                                        loadAbandonedCart: loadAbandonedCart
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-landing",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container kf-react-container cart-landing",
                                            children: [
                                                !abandonedFlag && isAbandonedCart && (cartData === null || cartData === void 0 ? void 0 : (ref5 = cartData.cartItems) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "back-to-cart",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                                                            alt: "Back",
                                                            className: "pr-10 pb-5",
                                                            height: "20",
                                                            width: "40"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "back-to-cart-text",
                                                            onClick: returnToCart,
                                                            children: "Back to Cart"
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row no-gutters row-space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((cartData === null || cartData === void 0 ? void 0 : (ref6 = cartData.cartItems) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 ? "col-lg-9 cart-item-list-section" : "col-lg-12", " ml-full-width "),
                                                            children:  true && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems/* default */.Z, {
                                                                page: "cart",
                                                                loading: isCartLoading,
                                                                i18n: staticText,
                                                                qtyLoading: qtyLoading,
                                                                cartItems: cartData === null || cartData === void 0 ? void 0 : cartData.cartItems,
                                                                onQuantityChange: handleQuantityChange,
                                                                dispatchCallback: dispatchCallbackHandler,
                                                                estimatedTotal: cartData === null || cartData === void 0 ? void 0 : cartData.estimatedTotal,
                                                                cartId: activeCart === null || activeCart === void 0 ? void 0 : activeCart.id,
                                                                cartKey: cartKey,
                                                                isIscUser: isIscUser,
                                                                checkoutUrl: "".concat(checkoutUrl.current, "?pin=").concat(zipcode),
                                                                currencySign: currencySign.current,
                                                                disableCheckout: (cartData === null || cartData === void 0 ? void 0 : (ref7 = cartData.cartItems) === null || ref7 === void 0 ? void 0 : ref7.length) === 0 || showAlert,
                                                                showAlert: showAlert,
                                                                specFiles: cartData === null || cartData === void 0 ? void 0 : cartData.specFiles,
                                                                isAuth: isAuth,
                                                                username: firstName,
                                                                isCartPage: true,
                                                                errors: errors,
                                                                abandonedFlag: abandonedFlag,
                                                                isAbandonedCart: isAbandonedCart,
                                                                showToast: showToastHandler,
                                                                loadAbandonedCart: loadAbandonedCart,
                                                                handleAbandonedCarts: showAbandonedCarts,
                                                                showBundleModal: setShowBundleModal,
                                                                inventoryData: inventoryData,
                                                                setCartQtyLoad: setCartQtyLoad,
                                                                handleSelection: handleSelection,
                                                                setLoadingText: setLoadingText
                                                            })
                                                        }),
                                                        (cartData === null || cartData === void 0 ? void 0 : (ref8 = cartData.cartItems) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-full-width order-summary-cart",
                                                            children: [
                                                                isAbandonedCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "row no-gutters pb-30",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_CustomerInformation, {
                                                                        email: activeCart.customerEmail,
                                                                        address: activeCart.billingAddress,
                                                                        staticText: staticText
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* default */.Z, {
                                                                    i18n: staticText,
                                                                    promoError: promoError,
                                                                    status: status,
                                                                    toastError: showToastHandler,
                                                                    zipcode: zipcode,
                                                                    dispatchCallback: dispatchCallbackHandler,
                                                                    cartId: activeCart === null || activeCart === void 0 ? void 0 : activeCart.id,
                                                                    estimatedTotal: cartData === null || cartData === void 0 ? void 0 : cartData.estimatedTotal,
                                                                    cartKey: cartKey,
                                                                    isIscUser: isIscUser,
                                                                    checkoutUrl: checkoutUrl.current,
                                                                    currencySign: currencySign.current,
                                                                    showAlert: showAlert,
                                                                    specFiles: cartData === null || cartData === void 0 ? void 0 : cartData.specFiles,
                                                                    isAuth: isAuth,
                                                                    username: firstName,
                                                                    isCartPage: true,
                                                                    errors: errors,
                                                                    recoveredStatus: recoveredStatus,
                                                                    abandonedFlag: abandonedFlag,
                                                                    handleAbandonedCarts: showAbandonedCarts,
                                                                    disableCheckout: (cartData === null || cartData === void 0 ? void 0 : (ref9 = cartData.cartItems) === null || ref9 === void 0 ? void 0 : ref9.length) === 0 || showAlert,
                                                                    loadAbandonedCart: loadAbandonedCart,
                                                                    inventoryCheck: inventoryCheck,
                                                                    isAbandonedCart: isAbandonedCart,
                                                                    redirectCallback: setRedirect,
                                                                    stickyCheckout: stickyCheckout,
                                                                    setStickyCheckout: setStickyCheckout,
                                                                    checkoutSeen: checkoutSeen,
                                                                    setCheckoutSeen: setCheckoutSeen,
                                                                    ref: childRef,
                                                                    promoCodesList: promoCodesList,
                                                                    promo: promo,
                                                                    setPromo: setPromo,
                                                                    updatePromoList: updatePromoList,
                                                                    ...cartData
                                                                })
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartInfo/* default */.Z, {
                                                            i18n: staticText,
                                                            supportLine: contactnumber
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityModal, {
                        showModal: showModal,
                        setShowModal: setShowModal,
                        modalText: modalText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakBundle_BreakBundle, {
                        showModal: showBundleModal,
                        setShowModal: setShowBundleModal,
                        onConfirm: handleBundleBreak
                    })
                ]
            }),
            isCheckoutMergeModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartUpdatedModal/* default */.Z, {
                isCheckoutModal: isCheckoutMergeModal,
                staticTexts: staticText,
                isCartLandingPage: true
            }) : null
        ]
    });
};
/* harmony default export */ var Landing = (CartLanding);


/***/ }),

/***/ 22657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36513);




const LandingFiller = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cart-landing",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container kf-react-container cart-landing",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row no-gutters row-space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-lg-9 cart-item-list-section ml-full-width",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "cart-landing__content",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row no-gutters cart-items",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row no-gutters",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "col-lg-12 col-sm-6 col-md-6 cart-header",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "cart-items__title",
                                                        role: "heading",
                                                        "aria-level": "1",
                                                        "aria-label": "Your Cart 0 items",
                                                        "data-testid": "cartItem-title",
                                                        children: "Your Cart"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "mobile-share-cart-id",
                                                        children: [
                                                            "Cart ID:",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "shimmer",
                                                                style: {
                                                                    width: 200,
                                                                    height: "auto"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row cart-items__th no-gutters cart-table-header",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12 col-sm-6 col-md-6 d-sm-block",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "col-4 d-none d-sm-block text-left cart-items__td px-0",
                                                        "aria-hidden": "true",
                                                        children: "Item"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12 col-sm-6 col-md-6 align-self-end",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "row mx-0 px-0 cart-items__td-container",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-5 d-none d-sm-block cart-items__td cart-td-unit-price",
                                                                "aria-hidden": "true",
                                                                children: "Item Price"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-3 d-none d-sm-block text-center cart-items__td px-0",
                                                                "aria-hidden": "true",
                                                                children: "Quantity"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-4 d-none d-sm-block text-right cart-items__td px-0",
                                                                "aria-hidden": "true",
                                                                children: "Total"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row cart-item no-gutters",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12 col-sm-6 mobile-full-width col-md-6 print-left",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "cart-item__summary",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                role: "button",
                                                                className: "gbh-data-layer",
                                                                tabindex: "0",
                                                                href: "/cart#",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "img-wrapper",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                        className: "cart-item__image",
                                                                        src: _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                                                        width: 120,
                                                                        height: 160
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                                                className: "cart-item__specs",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "cart-item__brand shimmer",
                                                                        style: {
                                                                            width: 100,
                                                                            height: 15
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        role: "button",
                                                                        className: "gbh-data-layer",
                                                                        tabindex: "0",
                                                                        href: "#",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "cart-item__name shimmer-loading__title shimmer",
                                                                            style: {
                                                                                marginTop: 20,
                                                                                marginBottom: 20
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "cart-item__desc shimmer",
                                                                        style: {
                                                                            marginBottom: 8,
                                                                            height: 15
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "cart-item__desc shimmer",
                                                                        style: {
                                                                            marginBottom: 8,
                                                                            height: 15
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "cart-item__desc shimmer",
                                                                        style: {
                                                                            marginBottom: 8,
                                                                            width: 100,
                                                                            height: 15
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12 col-sm-6 col-md-6 cart-item__info print-right",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "row cart-item__qty-price cart-qty-price-mobile mx-0 px-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "cart-item__qty-mobile",
                                                                children: "\xa0"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-5 cart-item__discount-container discount-container-padding",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "cart-item__price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "cart-item__total-price hide-mobile-price",
                                                                            "aria-description": "Unit Price",
                                                                            children: "-"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "col-2 text-right cart-item__total px-0 mobile-total-price",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "cart-item__total-price",
                                                                                "aria-description": "Total",
                                                                                children: "-"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                                                            className: "show-mobile"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-3 cart-item__qty px-0",
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "col-4 text-right cart-item__total px-0 hide-price-popup-mobile",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "cart-item__total-price hide-mobile-price",
                                                                    "aria-description": "Total",
                                                                    children: "-"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "clear"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-12",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "cart-item__cta-wrapper hide-mobile-checkout-section",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "remove-sec-cart",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "cart-item__cta",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        tabindex: "0",
                                                                        role: "button",
                                                                        "aria-label": "Vive™ Remove",
                                                                        children: "Remove"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "clear"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "ml-full-width order-summary-cart",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row no-gutters order-summary-wrapper sticky-order",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-12 pl-0 pr-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "order-summary",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "order-summary__title",
                                                role: "heading",
                                                "aria-level": "2",
                                                children: "Order Summary"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "order-summary__item",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "order-summary__item--label",
                                                        children: "Subtotal"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "order-summary__item--value",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: "-"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "order-summary__item",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "order-summary__item--label",
                                                        children: "Standard Shipping"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "order-summary__item--value",
                                                        children: "FREE"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                role: "presentation",
                                                "aria-hidden": "true",
                                                className: "order-summary__separator cart_custom_margin_hr"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "order-summary-mobile-sticky is-sticky-load",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "order-summary__item estimated-total",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "order-summary__item--label",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "order-summary__item--label-wrapper",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "order-summary__item--label-title",
                                                                        children: "Total"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "order-summary__item--value-large",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: "-"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "order-summary__item-hr",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                            role: "presentation",
                                                            "aria-hidden": "true",
                                                            className: "order-summary__separator cart_custom_margin_hr"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "order-summary__item--tax-container pb-10",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "order-summary__item--label tax-label",
                                                                children: [
                                                                    " ",
                                                                    "Tax"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "order-summary__item--label-description",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: "Including"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "order-summary__item--label-description--number-format",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "-"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: " in taxes"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "Button_buttonWrapper__9Vvy_ kf-react-button button gbh-data-layer checkout-btn-group large primary flexible",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "kf-react-button button gbh-data-layer checkout-btn-group large primary flexible",
                                            tabindex: "0",
                                            href: "#",
                                            children: "Checkout"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingFiller);


/***/ }),

/***/ 61047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CustomerInformationWrapper":"CustomerInformation_CustomerInformationWrapper__5N90G"};

/***/ }),

/***/ 46104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breakBundle":"break-bundle_breakBundle__VNUbW"};

/***/ }),

/***/ 1478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cartIsfcUser":"LookUpCart_cartIsfcUser__HbXMr"};

/***/ }),

/***/ 68122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quantityModal":"QuantityModal_quantityModal___InQv"};

/***/ })

}]);